import { MDBBadge, MDBBtn, MDBCard,MDBCardBody, MDBCol, MDBRow } from "mdb-react-ui-kit";
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { generateClient } from "aws-amplify/api";
import { captureError } from '../../../utils/sentryHelpers';
import { getLocalizedText } from '../../../utils/localizedText';
import { compareBoothNumbers } from '../../../utils/boothMap';

// Custom Product Forms
import CompanyProfile from './after-purchase-forms/CompanyProfile';

export default function ThankYou() {
    const client = generateClient();
    const { t, i18n } = useTranslation();
    const { orderId } = useParams();

    const [data, setData] = useState({});
    const [order, setOrder] = useState({});
    const [ dataSavedSuccess, setDataSavedSuccess ] = useState(false);

    const getOrder = async () => {
        try {
            const response = await client.graphql({
                query: /* GraphQL */ `
                query GetOrder($id: ID!) {
                    getOrder(id: $id) {
                    id
                    orderNumber
                    status
                    paymentStatus
                    deliveryStatus
                    lineItems {
                        items {
                         id
                         qty
                         boothNumber
                         product {
                            id
                            type
                            name {
                                language
                                text
                            }
                            description{
                                language
                                text
                            }
                            price
                            sku
                        }
                        }
                        nextToken
                    }
                    notes
                    deliveryAddress {
                        firstName
                        lastName
                        title
                        salutation
                        street
                        street2
                        streetNumber
                        company
                        contactPerson
                        city
                        zip
                        countryCode
                        __typename
                    }
                    billingAddress {
                        firstName
                        lastName
                        title
                        salutation
                        street
                        street2
                        streetNumber
                        company
                        contactPerson
                        city
                        zip
                        countryCode
                        __typename
                    }
                    billingEmail
                    createdAt
                    companyOrdersId
                    userOrdersId
                   
                    __typename
                    }
                }
                `,
                variables: { id: orderId }
            });
            setOrder(response.data.getOrder);
        } catch (error) {
            console.error(error);
            captureError(error, {
                feature: 'checkout',
                operation: 'fetch-order',
                context: { orderId }
            });
        }
    }

    useEffect(() => {
        if (orderId) getOrder();
    }, [orderId]);

    const updateOrder = async () => {
    try {
      const response = await client.graphql({
        query: /* GraphQL */ `
        mutation UpdateOrder($input: UpdateOrderInput!) {
          updateOrder(input: $input) {
            id
          }
        }
      `,
        variables: {
          input: {
            id: orderId,
           data: JSON.stringify(data)
          }
        }
      })
      //console.log(response)
        setDataSavedSuccess(true)
    }
    catch (error) {
      console.error(error)
      captureError(error, {
          feature: 'checkout',
          operation: 'update-order-data',
          context: { orderId, data }
      });
    }
    }

    const handleUpdateOrder = () => {
    updateOrder();
    }

    const lineItems = (order.lineItems?.items || []).filter(Boolean);
    const firstLineItem = lineItems[0];
    const bookedBooths = lineItems
        .filter((item) => item.boothNumber)
        .sort((a, b) => compareBoothNumbers(a.boothNumber, b.boothNumber));


  return (
<>
<MDBRow className="d-flex align-items-center m-0" style={{height: "90vh"}}>
    <MDBCol size="12" className="d-flex align-items-center justify-content-center" style={{height: "100%"}}>
        <MDBCard className="col-md-10 col-xl-9 col-xxl-8 mt-xl-5">
            <MDBCardBody>
                <div>
                    <h1>{t("Thank You For Your Order")}</h1>
                    {/* placeOrder sends no confirmation e-mail (code commented out there) - so promise none */}
                    <p>{t("Your order has been received.")}</p>
                    {bookedBooths.length > 0 && (
                    <div className="mb-3">
                        <p className="fw-bold mb-1">{t("Your booths")}</p>
                        <ul className="list-unstyled mb-0">
                            {bookedBooths.map((item) => (
                                <li key={item.id || item.boothNumber}>
                                    <MDBBadge color="primary" className="me-2">{t("Booth {{number}}", { number: item.boothNumber })}</MDBBadge>
                                    {getLocalizedText(item.product?.name)}
                                </li>
                            ))}
                        </ul>
                    </div>
                    )}
                    {firstLineItem?.product?.sku === "cp-company" &&
                    <>
                    <p className="fw-bold">{t("Your order contains a product that requires further information")}</p>
                    <p>{t("Please fill out the form below to provide us with the necessary information to complete your order.")}</p>
                    <CompanyProfile
                        data={data}
                        setData={setData}
                        handleUpdateOrder={handleUpdateOrder}
                        dataSavedSuccess={dataSavedSuccess}
                    />
                    </>
                    }
                    <Link to="/bookings"><MDBBtn color="primary" href="/user/orders">{t("View Orders")}</MDBBtn></Link>
                    {order.orderNumber !== null && order.orderNumber !== undefined && order.orderNumber !== ""
                        ? <p className="text-muted mt-5">{t("Order number")}: {order.orderNumber}</p>
                        : order.id && <p className="text-muted mt-5">{t("Order-ID")}: {order.id}</p>}
                </div>
            </MDBCardBody>
        </MDBCard>
    </MDBCol>
</MDBRow>
</>
    
  );
}